import { render } from "./SnsLogin.vue?vue&type=template&id=00b06ccc&scoped=true"
import script from "./SnsLogin.vue?vue&type=script&lang=js"
export * from "./SnsLogin.vue?vue&type=script&lang=js"

import "./SnsLogin.vue?vue&type=style&index=0&id=00b06ccc&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b06ccc"]])

export default __exports__